//选型路由
export default [
  //泵选型 第一步(两步法)
  {
    path: "/:lang/Select/ByPara2/SelParas",
    name: "SelParas2",
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Select/ByPara2/Index.vue"),
  },
  //选型待选列表
  {
    path: "/:lang/Select/PumpList/Index",
    name: "PumpList",
    alias: [
      "/:lang/Select/PumpList/Index",
      "/:lang/Select/PumpList/Index",
      "/:lang/Select/PumpList/Index",
      "/:lang/Select/PumpList/Index",
      "/:lang/Select/PumpList/Index",
    ],
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      modulsName: "select",
      noPermissionValidate: true,
      keepAlive: false,
      isLoaded: false,
    },
    component: () => import("/@/views/Select/PumpList/Index.vue"),
  },
  //泵详细(固定路由)
  {
    path: "/:lang/byParas/Index",
    name: "byParas/Index",
    alias: [
      "/:lang/byParas/Index",
      "/:lang/byParas/Index",
      "/:lang/byParas/Index",
      "/:lang/byParas/Index",
      "/:lang/byParas/Index",
    ],
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: true,
    },
    component: () => import("/@/views/Detail/byParas/Index.vue"),
  },
  //泵详细(动态路由:电子样本用)
  {
    path: "/:lang/Pump/Index/:sid/:pid",
    name: "PumpDetailIndex",
    alias: [
      "/:lang/Pump/Index/:sid/:pid",
      "/:lang/Pump/Index/:sid/:pid",
      "/:lang/Pump/Index/:sid/:pid",
      "/:lang/Pump/Index/:sid/:pid",
      "/:lang/Pump/Index/:sid/:pid",
    ],
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      modulsName: "ebook",
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: true,
    },
    component: () => import("/@/views/Detail/byParas/Index.vue"),
  },
  //相似设计 选型参数(三步法)
  {
    path: "/:lang/Select/BySimu/SelParas",
    name: "SelParas3",
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Select/BySimu/SelParas.vue"),
  },
  //相似设计 选型结果(三步法)
  {
    path: "/:lang/Select/BySimu/PumpList",
    name: "PumpList3",
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Select/BySimu/PumpList.vue"),
  },
  //相似设计-泵详细
  {
    path: "/:lang/BySimu/Index",
    name: "PumpDetailBySimu",
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      modulsName: "ebook",
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: true,
    },
    component: () => import("/@/views/Detail/BySimu/Index.vue"),
  },
    //快速选型
    {
      path: "/:lang/Select/ByQuick/Index",
      name: "QuickSelectIndex",
      meta: {
        title: "",
        cache: false,
        noFrame: false,
        modulsName: "select",
        noPermissionValidate: true,
        keepAlive: true,
        isLoaded: true,
      },
      component: () => import("/@/views/Select/ByQuick/index.vue"),
    },
];
